import PocketBase from 'pocketbase'
const url = import.meta.env.VITE_PB_URL
export const pbClient = new PocketBase(url)